import { FileSpreadsheet } from "lucide-react";
import { Loader } from "@/components/shared/loader";
import { Input } from "@/components/ui/input";
import { useObsWizard } from "@/features/obs/hooks/obs-wizard-context";

/** Step 2 — pick the workbook and let the profiler read it. */
export function StepFile() {
  const { draft, workbook, pickWorkbook, busy, profiling } = useObsWizard();

  return (
    <div className="rounded-lg border border-dashed border-border p-4">
      <div className="flex items-center gap-3">
        <FileSpreadsheet className="size-8 shrink-0 text-muted-foreground" />
        <div className="min-w-0 flex-1 space-y-2">
          <Input
            type="file"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            disabled={busy}
            onChange={(e) => {
              const picked = e.target.files?.[0];
              if (picked) pickWorkbook(picked);
            }}
          />

          {/*
            ⚠️ A FILE INPUT CANNOT BE REFILLED IN CODE — only a person may set its
            value. So after a reload the input reads empty even though the wizard
            still holds the workbook, and without this line an intact draft looks
            like a lost one and the operator re-picks the same file. Says which
            file is attached, not merely that one is.
          */}
          {draft.workbookName && (
            <p className="text-xs text-emerald-600">
              الملف المرفق:{" "}
              <span dir="ltr" className="font-mono">
                {draft.workbookName}
              </span>
              {!workbook && !profiling && (
                <span className="text-muted-foreground">
                  {" "}
                  — تعذّر استرجاع الملف نفسه بعد إعادة التحميل، أعد اختياره قبل
                  المتابعة.
                </span>
              )}
            </p>
          )}

          <p className="text-xs text-muted-foreground">
            سيُقرأ الملف ليُقترح معنى كل عمود. لا يُحفظ شيء على الموقع في هذه
            الخطوة، ولن يظهر أي رقم قبل أن تؤكّد.
          </p>

          {profiling && (
            <p className="flex items-center gap-2 text-xs text-muted-foreground">
              <Loader /> جارٍ قراءة الملف…
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
